import { render, staticRenderFns } from "./MacrosCategoryAdd.vue?vue&type=template&id=01d675ca"
import script from "./MacrosCategoryAdd.vue?vue&type=script&lang=js"
export * from "./MacrosCategoryAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports